import {
    GET_ATTENTIONS,
    GET_ATTENTIONS_SUCCESS,
    GET_ATTENTIONS_ERROR,

    GET_AFFILIATES,
    GET_AFFILIATES_SUCCESS,
    GET_AFFILIATES_ERROR,

    SET_LIST_CONFIG,

    SET_SELECTED_ATTENTION,
    SET_SELECTED_AFFILIATE,
    // [MODULE REDUCER] IMPORT ACTIONS
} from './attentions.actions';
import {REQUEST_STATUS} from '../utils/consts';

const initialState = {
    affiliates: {results: [], total: 0},
    affiliatesListConfig: {
        page: 1,
        size: 10,
        orderBy: [],
        searchTags: {},
    },
    getAffiliatesState: REQUEST_STATUS.NONE,
    affiliateSearchRecomendations: [],

    selectedAffiliate: {},

    attentions: {results: [], total: 0},
    attentionListConfig: {
        page: 1,
        size: 10,
        orderBy: [],
        searchTags: {},
    },
    getAttentionsState: REQUEST_STATUS.NONE,

    selectedAttention: {},

    queryList: [],
    // [MODULE REDUCER] INITIAL STATE
};

/* const mockState = {
    affiliates: {
       /!* results: [
            {id: 1, firstName: 'Juan', lastName: 'Rod', dni: 24869534, plan: 'Plan 605', affiliateNumber: 56165181451, state: 'Activo'},
            {id: 2, firstName: 'Andy', lastName: 'Less', dni: 48519513, plan: 'Plan 42', affiliateNumber: 16158455135, state: 'Activo'},
            {id: 3, firstName: 'Bon', lastName: 'Jovi', dni: 11548118, plan: 'Plan 745', affiliateNumber: 44845618845, state: 'Inactivo'},
        ],
        total: 3,*!/
    },
    affiliatesListConfig: {...initialState.affiliatesListConfig, page: 0},
    getAffiliatesState: REQUEST_STATUS.SUCCESS,
    affiliateSearchRecomendations: ['Juan Rod', 'Andy Less', 'Bon Jovi'],

    attentions: {
       /!* results: [
            {id: 1, date: '12/12/12', branch: 'Sede 5', query: 'Kinesiologia', copay: 300, data1: 'Inverso', data2: 'Profundo', data3: 'NO'},
            {id: 2, date: '32/13/99', branch: 'Sede -1', query: 'Traumatologia', copay: 150, data1: 'Excelente', data2: 'Improbable', data3: 'SI'},
            {id: 3, date: '01/01/04', branch: 'Sede 2', query: 'Rinoplastia', copay: 999, data1: 'Dudoso', data2: 'Agudo', data3: 'NO'},
        ],
        total: 3,*!/
    },
    attentionsListConfig: {...initialState.affiliatesListConfig, page: 0},
    getAttentionsState: REQUEST_STATUS.SUCCESS,

    queryList: ['Kinesiologia', 'Traumatoligia', 'Reumatologia', 'Analogia', 'Idemlogia'],
    // [MODULE REDUCER] INITIAL STATE
};*/

const attentionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ATTENTIONS:
        case GET_ATTENTIONS_SUCCESS:
        case GET_ATTENTIONS_ERROR:
            return {
                ...state,
                getAttentionsState: {
                    loading: action.type === GET_ATTENTIONS,
                    success: action.type === GET_ATTENTIONS_SUCCESS,
                    error: action.type === GET_ATTENTIONS_ERROR && action.error,
                },
            };

        case GET_AFFILIATES:
        case GET_AFFILIATES_SUCCESS:
        case GET_AFFILIATES_ERROR:
            return {
                ...state,
                getAffiliatesState: {
                    loading: action.type === GET_ATTENTIONS,
                    success: action.type === GET_ATTENTIONS_SUCCESS,
                    error: action.type === GET_ATTENTIONS_ERROR && action.error,
                },
            };

        case SET_LIST_CONFIG:
            const list = action.list;
            const config = action.config;
            if ( list !== 'affiliatesListConfig' && list !== 'attentionListConfig' ) return state;

            return {
                ...state,
                [list]: {...state[list], ...config},
            };
        case SET_SELECTED_ATTENTION:
            return {
                ...state,
                selectedAttention: action.selectedAttention,
            };
        case SET_SELECTED_AFFILIATE:
            return {
                ...state,
                selectedAffiliate: action.selectedAffiliate,
            };
        default: return state;
    };
};

export default attentionsReducer;
